/* eslint-disable no-nested-ternary */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import ImageV2 from 'components_v2/common/ImageV2';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import { getImageFromImageObject } from 'components/Image/utils';
import Link from 'components/Link';
import { convertHtmlToStringText } from 'utils/common';
import classNames from 'classnames';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import RelatedStoriesCardBottom from 'components_v2/mobile/RelatedStoriesCardBottom/RelatedStoriesCardBottom';
import Icon from '../CardV2/Icon';
import s from './CardCarousel.scss';
import { PRC_FOR_FTU, PRC_FOR_SUBSCRIBED } from '../../../constants';

function customOnError(e) {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
}

function getGAVal(gaData, data) {
  if (typeof gaData !== 'string' || !gaData) {
    return '';
  }

  let type = 'Article';
  if (
    data.hasVideo ||
    data.hasvideo ||
    data.type === 'video' ||
    data.tn === 'video'
  ) {
    type = 'Video';
  } else if (data.type === 'photostory' || data.tn === 'photostory') {
    type = 'Photo';
  }
  return gaData.replace('$type', type);
}

const settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
  pauseOnFocus: false,
  dots: false,
  arrows: false,
  swipeToSlide: true,
  autoplay: true,
  draggable: false,
  infinite: true,
  dotsClass: s.dots,
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

function CardCarousel(props) {
  const {
    showDescription,
    showPhotosCount,
    onClick,
    itemClass,
    linkData,
    htmlKeys,
    shouldNotlazyloadImage,
    imgFit,
    imgWidth = '600',
    cssObj: { figureClass = '', imgCont = '', titleCont = '' } = {},
    isInlineSmallIconCard,
    data,
  } = props;

  const [currentSlide, setCurrentSlide] = useState(0);
  const useIntersectionObeserver = useContext(UseIntersectionObeserver);
  const ImageElement = useIntersectionObeserver ? ImageV2 : Image;
  const photosCount = data.photosCount || data.imgcount;
  const { titlePrefix = '' } = data;
  const { imagelist } = data;

  const {
    isLeadImageNews, // for cover layout
    isLeadTypeTwo, //lead for City, Business
    isLeadVideo,
    isMobileInlineVideo,
    isLeadPhoto,
    isVerticalTile,
    isPhotoWidget, // for Desktop "photo" widget only
    isVideoWidget, // for Desktop "Videos" widget only
    timeStampHtml,
    plusIconNotRequired,
    target,
    isPhotoVisualStory,
    viewga,
    istoipListing,
    cardClass,
    userData,
    paidStoriesMsid,
    ga4Type,
    ga4Category,
    gaIndex,
    enableRelatedStoriesSupport,
  } = props;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;

  settings.beforeChange = (current, next) => {
    setCurrentSlide(next);
  };
  const { imagecaptn } = imagelist[currentSlide];
  let { showImageCaption } = imagelist[currentSlide];
  const captionTrimVal = props.insertCaptionPlatform === 'mobile' ? 54 : 75;
  showImageCaption = showImageCaption !== 'false';

  const showPriceTag =
    userData &&
    Object.keys(userData).length !== 0 &&
    prcValue !== PRC_FOR_FTU &&
    prcValue !== PRC_FOR_SUBSCRIBED &&
    data.isLead &&
    !paidStoriesMsid.includes(data.id);
  const isTypeVideo =
    data.hasVideo ||
    data.hasvideo ||
    data.type === 'video' ||
    data.tn === 'video' ||
    isMobileInlineVideo;
  const isPhotoStory = data.type === 'photostory' || data.tn === 'photostory';
  const isToiPlusStory = data.cs === 'prime';
  const isIconNeeded =
    isPhotoStory || isTypeVideo || isToiPlusStory || showPriceTag;
  const figureClassName = classNames({
    [s.card]: true,
    [s.leadthumb]:
      isLeadImageNews || isLeadVideo || isLeadPhoto || isLeadTypeTwo,
    [s.Smallleadthumb]: isLeadTypeTwo,
    [s.mediathumb]: isVerticalTile || isPhotoWidget,
    [s.photoWidget]: isPhotoWidget,
    [s.videoWidget]: isVideoWidget,
    [s.photoStory]: isPhotoVisualStory,
    [s.videomediathumb]: isMobileInlineVideo && isVerticalTile,
    [s.cardwithoutthumb]: cardClass === 'cardwithoutthumb' && !isVerticalTile,
    [s.no_bdr_last]: cardClass === 'cardwithoutthumb' && !isVerticalTile,
    [s.mediathumbwithmargin]:
      cardClass === 'withoutlead4list' && isVerticalTile,
  });
  const contentVisibilityClass = classNames({
    [s.card_intrinsic_size]: isInlineSmallIconCard,
    [s.video_card_intrinsic_size]: isMobileInlineVideo && isVerticalTile,
    [s.leadthumb_intrinsic_size]:
      isLeadImageNews || isLeadVideo || isLeadPhoto || isLeadTypeTwo,
  });
  const cardInner = classNames({
    [s.cardwrapper]: true,
    [s.txtwothumb]: cardClass === 'cardwithoutthumb' && !isVerticalTile,
  });

  let leadPhotostoryVideoClass = '';
  if (isLeadImageNews && (isTypeVideo || isPhotoStory)) {
    leadPhotostoryVideoClass = 'leadPhotostoryVideoClass';
  }

  let titleContainerClass;
  if (isLeadTypeTwo || isLeadImageNews) {
    titleContainerClass = s.headingwithicon;
  } else if (isLeadVideo || isPhotoWidget) {
    titleContainerClass = s.titleWithIcon;
  }

  let headingTxt = data.hl;
  if (htmlKeys && htmlKeys instanceof Array && htmlKeys.indexOf('hl') > -1) {
    headingTxt = convertHtmlToStringText(data.hl);
  }

  let descTxt = data.des || data.syn;
  if (htmlKeys && htmlKeys instanceof Array && htmlKeys.indexOf('des') > -1) {
    descTxt = convertHtmlToStringText(data.des || data.syn);
  }
  descTxt = descTxt || '';
  const shouldShowDescription =
    showDescription && typeof descTxt === 'string' && descTxt !== '';
  let _target = target ? '_blank' : '';

  if (data.target && data.target === '_blank') {
    _target = data.target;
  }

  const isRelatedStoriesPresent =
    enableRelatedStoriesSupport &&
    data &&
    Array.isArray(data.relatedStories) &&
    data.relatedStories.length > 1;

  const cardFigureDom = (
    <figure
      className={`${figureClassName} ${itemClass} ${figureClass} ${props.useContentVisibilty &&
        contentVisibilityClass}`}
      key={data.id}
      data-videomsid={data.id}
      data-scrollga={viewga}
    >
      <Link
        to={data.wu}
        className={cardInner}
        onClick={onClick}
        data={linkData}
        data-newga={getGAVal(props.newga, data)}
        doNotChangeURL={props.doNotChangeURL}
        target={_target}
        ga4Data={
          ga4Type && [
            {
              event: 'user_click',
              type: `${ga4Type}`,
              category: `${'story_click' || ga4Category}`,
              story_no: `${gaIndex}`,
              msid: data?.id,
            },
          ]
        }
      >
        {!(cardClass === 'cardwithoutthumb' && !isVerticalTile) && (
          <div
            className={`${s.cardimage} ${leadPhotostoryVideoClass} ${imgCont}`}
          >
            <div className={`${s.content} cardactive`}>
              {/* This is to show live button on imagetop in case of live story */}
              {props.showLiveBtn && data.tn === 'liveblog' ? (
                <div className={s.liveBtn}>Live</div>
              ) : null}
              <Slider {...settings}>
                {imagelist.map(item => {
                  const image = {};
                  image.width = 600;
                  image.id = item.imageid;
                  image.version = item.imagesize;

                  const imageSrc = getImageFromImageObject(image);

                  return (
                    <ImageElement
                      key={data.imageid || data.id}
                      width={imgWidth}
                      src={imageSrc}
                      placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                      alt={headingTxt}
                      altTitle={headingTxt}
                      lazyload={!shouldNotlazyloadImage}
                      onError={customOnError}
                      offsetVertical={300}
                      className={classNames({
                        [s[`fit_${imgFit}`]]: imgFit,
                      })}
                    />
                  );
                })}
              </Slider>
            </div>
            {isIconNeeded &&
              !(
                isLeadImageNews ||
                isLeadTypeTwo ||
                isLeadVideo ||
                isPhotoWidget ||
                plusIconNotRequired
              ) &&
              Icon(
                isPhotoStory,
                isTypeVideo,
                showPhotosCount && photosCount,
                isInlineSmallIconCard,
                isMobileInlineVideo,
                isToiPlusStory,
              )}
          </div>
        )}
        {isLeadImageNews || isLeadTypeTwo || (isLeadVideo || isPhotoWidget) ? (
          <div
            className={`${titleContainerClass} ${titleCont} ${
              props.insertCaptionPlatform && imagecaptn && showImageCaption
                ? s.cardWithCaption
                : ''
            }`}
          >
            {(isLeadTypeTwo ||
              isLeadImageNews ||
              isLeadVideo ||
              isPhotoWidget ||
              plusIconNotRequired) &&
              Icon(
                isPhotoStory,
                isTypeVideo,
                showPhotosCount && photosCount,
                isInlineSmallIconCard,
                isMobileInlineVideo,
                isToiPlusStory,
              )}
            {titlePrefix !== 'undefined' &&
              titlePrefix !== '' &&
              (!(data.tn === 'photostory' || data.tn === 'video') && (
                <span className={s.leadToiplus} />
              ))}
            <figcaption>{headingTxt}</figcaption>
            {props.insertCaptionPlatform &&
              imagecaptn &&
              showImageCaption && (
                <>
                  <figcaption>
                    {imagecaptn.length > captionTrimVal
                      ? `${imagecaptn.substr(0, captionTrimVal - 3)}...`
                      : imagecaptn}
                  </figcaption>
                </>
              )}
            {timeStampHtml && <p>{timeStampHtml}</p>}
            {shouldShowDescription && <p>{descTxt}</p>}
          </div>
        ) : null}
      </Link>
    </figure>
  );

  const wrappedCardFigureDom = isRelatedStoriesPresent ? (
    <div
      className={`relatedStoriesContainer ${
        isLeadImageNews ? 'relatedCarosuelLeadNews' : ''
      }`}
    >
      {cardFigureDom}
      <RelatedStoriesCardBottom data={data} isLeadImageNews={isLeadImageNews} />
    </div>
  ) : (
    cardFigureDom
  );

  return <>{!istoipListing && wrappedCardFigureDom}</>;
}
CardCarousel.propTypes = {
  // mediatype: PropTypes.string,
  // description: PropTypes.string,
  data: PropTypes.shape({}).isRequired,
  isLeadImageNews: PropTypes.bool,
  isLeadTypeTwo: PropTypes.bool,
  //isLeadTypeThree: PropTypes.bool,
  isLeadVideo: PropTypes.bool,
  showSectionName: PropTypes.bool,
  //videoWidget: PropTypes.bool,
  onClick: PropTypes.func,
  isLeadPhoto: PropTypes.bool,
  isMobileInlineVideo: PropTypes.bool,
  isInlineSmallIconCard: PropTypes.bool,
  isVerticalTile: PropTypes.bool,
  isPhotoWidget: PropTypes.bool,
  isVideoWidget: PropTypes.bool,
  itemClass: PropTypes.string,
  showDescription: PropTypes.bool,
  showLiveBtn: PropTypes.bool,
  linkData: PropTypes.shape({}),
  newga: PropTypes.string,
  htmlKeys: PropTypes.arrayOf(PropTypes.string),
  shouldNotlazyloadImage: PropTypes.bool,
  imgFit: PropTypes.string,
  imgWidth: PropTypes.string,
  cssObj: PropTypes.shape({}),
  timeStampHtml: PropTypes.string,
  plusIconNotRequired: PropTypes.bool,
  doNotChangeURL: PropTypes.bool,
  target: PropTypes.bool,
  showDuration: PropTypes.bool,
  showPhotosCount: PropTypes.bool,
  isPhotoVisualStory: PropTypes.bool,
  viewga: PropTypes.string,
  useContentVisibilty: PropTypes.bool,
  restProps: PropTypes.shape({}),
  cardClass: PropTypes.bool,
  istoipListing: PropTypes.bool,
  isWapView: PropTypes.bool,
  gaPageName: PropTypes.string,
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  tpPageName: PropTypes.string,
  isVertical: PropTypes.bool,
  toiPCardTheme: PropTypes.bool,
  priceTag: PropTypes.string,
  paidStoriesMsid: PropTypes.arrayOf(PropTypes.string),
  insertCaptionPlatform: PropTypes.string,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
  gaIndex: PropTypes.number,
  enableRelatedStoriesSupport: PropTypes.bool,
};
CardCarousel.defaultProps = {
  // mediatype: undefined,
  // description: undefined,
  isLeadImageNews: false,
  isLeadTypeTwo: false,
  plusIconNotRequired: false,
  //isLeadTypeThree: false,
  isLeadVideo: false,
  showSectionName: false,
  //videoWidget: false,
  isLeadPhoto: false,
  onClick: undefined,
  isMobileInlineVideo: false,
  isInlineSmallIconCard: false,
  isVerticalTile: false,
  isPhotoWidget: false,
  isVideoWidget: false,
  itemClass: '',
  showDescription: false,
  showLiveBtn: false,
  linkData: undefined,
  newga: '',
  htmlKeys: [],
  shouldNotlazyloadImage: false,
  imgFit: undefined,
  imgWidth: '600',
  cssObj: {},
  timeStampHtml: null,
  doNotChangeURL: false,
  target: false,
  showDuration: true,
  showPhotosCount: true,
  isPhotoVisualStory: false,
  viewga: '',
  useContentVisibilty: false,
  restProps: {},
  cardClass: false,
  istoipListing: false,
  isWapView: false,
  gaPageName: '',
  tpPageName: '',
  isVertical: false,
  userData: undefined,
  toiPCardTheme: false,
  priceTag: '',
  paidStoriesMsid: [],
  insertCaptionPlatform: '',
  ga4Type: '',
  ga4Category: '',
  gaIndex: '',
  enableRelatedStoriesSupport: false,
};

export default React.memo(CardCarousel);
